module.exports = __webpack_public_path__ + "static/media/Library.9d042061.mp3";